import { contextCache } from 'feathers-fletching';
import { setIn } from 'formik';
import { isNumbersOnly } from 'straightline-utils/validation';

export const cache = async (context) => {
  if (!context.service.options || !context.service.options.cacheMap) {
    throw new Error('cacheMap not defined on service');
  }

  return contextCache(context.service.options.cacheMap)(context);
};

export const stashCache = () => {
  let timeout = null;

  return async (context) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      const stash = async () => {
        await context.app.storage
          .set(
            context.path,
            JSON.stringify(context.service.options.cacheMap.map.dump())
          )
          .catch((error) => {
            context.app.get('sentryClient').captureException(error, {
              data: {
                method: 'set',
                path: context.path,
                payload: context.service.options.cacheMap.map.dump()
              }
            });
            return context.app.storage.del(context.path);
          })
          .catch((error) => {
            context.app.get('sentryClient').captureException(error, {
              data: {
                method: 'del',
                path: context.path,
                payload: context.service.options.cacheMap.map.dump()
              }
            });
          });
      };

      stash();
    }, 5000);

    return context;
  };
};

export const withSearch = (...options) => {
  return (context) => {
    if (!context.params.query) {
      return context;
    }

    const { $search, ...query } = context.params.query;

    if (!$search) {
      context.params.query = query;
      return context;
    }

    query.$and = [...(query.$and || [])];
    const $or = [];

    options.forEach((option) => {
      if (typeof option === 'function') {
        option($search, $or);
      }

      Object.entries(option).forEach(([prop, callback]) => {
        const operator = callback($search);
        if (operator) {
          $or.push({ [prop]: operator });
        }
      });
    });

    query.$and.push({ $or });

    context.params.query = query;

    return context;
  };
};

const phoneRegex = /[^0-9()\-\s]/;

withSearch.phone = (value) => {
  if (phoneRegex.test(value)) {
    return;
  }
  return { $iLike: `%${value}%` };
};

withSearch.string = (value) => {
  if (isNumbersOnly(value)) {
    return;
  }
  return { $iLike: `%${value}%` };
};

withSearch.text = (value) => {
  return { $iLike: `%${value}%` };
};

withSearch.number = (value) => {
  if (isNumbersOnly(value)) {
    return { $eq: value };
  }
};

withSearch.email = (value) => {
  if (value.includes(' ')) {
    return;
  }
  return withSearch.string(value);
};

/* Convert a ValidationError into the shape that Formik wants so it can map to form UI */
export const convertFormikError = (context) => {
  if (context.error.code === 420 && context.error.errors) {
    let formik = {};
    Object.entries(context.error.errors).forEach(([key, value]) => {
      formik = setIn(formik, key, value);
    });
    context.error.formik = formik;
  }
  return context;
};
